
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vc-loophole-calculator",
      function () {
        return require("private-next-pages/vc-loophole-calculator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vc-loophole-calculator"])
      });
    }
  